import { useDisclosure } from '@chakra-ui/react';

import { useScannedRelevosContext } from '../../../../contexts/ScannedRelevosContext';
import { useBorrowDepositItems, useReturnDepositItems } from '../../../../services/deposit';
import { ScannerMode } from '../../../RelevoAssignment/model/enums/scanner-mode.enum';
import { useDepositResultContext } from '../../context/DepositResultContext/DepositResultContext';
import { BorrowDepositModel } from '../../model/borrow-deposit-model';
import { DepositItemModel } from '../../model/deposit-item-model';
import { DepositModel } from '../../model/deposit-model';
import { DepositRequest } from '../../model/deposit-request';
import { ErrorDepositItemResponse } from '../../model/error-deposit-item-response';
import { ReturnDepositModel } from '../../model/return-deposit-model';

interface DepositState {
  deposit: DepositModel;
  successItems: DepositItemModel[];
  failureItems: ErrorDepositItemResponse[];
}

export const useDeposit = () => {
  const { mode, scannedRelevos, restaurantId } = useScannedRelevosContext();
  const { mutate: borrowDeposit, isLoading: isBorrowDepositLoading } = useBorrowDepositItems();
  const { mutate: returnDeposit, isLoading: isReturnDepositLoading } = useReturnDepositItems();
  const { deposit, successItems, failureItems, setDepositResult } = useDepositResultContext();
  const confirmDepositModal = useDisclosure();
  const depositResultModal = useDisclosure();

  const handleSuccess = () => {
    confirmDepositModal.onClose();
    depositResultModal.onOpen();
  };

  const confirm = () => {
    const request: DepositRequest = { uIds: scannedRelevos.map((relevo) => relevo.uId) };
    if (restaurantId) {
      if (mode === ScannerMode.DEPOSIT_ASSIGN) {
        borrowDeposit(
          { restaurantId, request },
          {
            onSuccess: (response: BorrowDepositModel) => {
              setDepositResult(response.deposit, response.borrowedItems, response.notBorrowedItems);
              handleSuccess();
            },
          },
        );
      } else if (mode === ScannerMode.DEPOSIT_RETURN) {
        returnDeposit(
          { restaurantId, request },
          {
            onSuccess: (response: ReturnDepositModel) => {
              setDepositResult(response.deposit, response.returnedItems, response.notReturnedItems);
              handleSuccess();
            },
          },
        );
      }
    }
  };

  const depositState: DepositState = {
    deposit,
    successItems,
    failureItems,
  };

  return {
    confirm,
    depositState,
    confirmDepositModal,
    depositResultModal,
    isLoadingConfirm: mode === ScannerMode.DEPOSIT_ASSIGN ? isBorrowDepositLoading : isReturnDepositLoading,
  };
};
